import { render, staticRenderFns } from "./PrepaymentAccounts.vue?vue&type=template&id=61464a85"
import script from "./PrepaymentAccounts.vue?vue&type=script&lang=js"
export * from "./PrepaymentAccounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports